import React, { Component, Fragment } from "react";
import Footer from "../components/common/Footer";
import Topbar from "../components/common/Topbar";
import PageTitle from "../components/home/PageTitle";
import Dashboard from "../components/home/Dashboard";

class HomePage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <div id="content-wrapper" className="d-flex flex-column home-page-layout">
          <div id="content">
            <Topbar />
            <div className="container-fluid dashboard-page py-4">
              <PageTitle Title="Dashboard" />
              <Dashboard />
            </div>
          </div>
          <Footer />
        </div>
      </Fragment>
    );
  }
}

export default HomePage;
